import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import { allSharedComponents } from "../../../../shared";
import {
  SpotActions,
  UserActions,
  centerInstructorsActions,
} from "../../../../redux/actions";
import {
  emptyString,
  modeConstants,
  translationConstants,
  centerInvitationStatusConstants,
  centerInvitationStatuses,
  viewPathConstants,
} from "../../../../constants";
import {
  changeTableSortIcons,
  getSortDirectionProperty,
} from "../../../../system";
import { getSportNames } from "../../../AdminPortal/Views/Spots/utilities";
import AddInstructorModal from "./Modals/AddInstructorModal";
import removeInstructorIcon from "../../../../assets/images/icon/remove_instructor_icon.svg";
import removeIcon from "../../../../assets/images/icon/remove_icon.svg";
import DeleteModal from "../../../../shared/components/Modals/DeleteModal";
import FilterComponent from "./FilterComponent";
import InstructorDetail from "../../../../shared/components/InstructorDetail";
import BTN_BACK from "../../../../assets/images/icon/arrow-left.svg";

const { DataTable, CustomModal } = allSharedComponents;
const defaultQueryExpression = "instructorId != null ";
const initialGridState = {
  length: 10,
  pageNumber: 1,
  orderBy: "instructorId desc",
  filterQuery: defaultQueryExpression,
  search: "",
};

const CenterInstructors = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { t, i18n } = useTranslation();
  const sortingInProgressRef = useRef(false);
  const publicData = useSelector(
    (state) => state.centerInstructors?.centerInstructorsData?.pageData
  );
  const centerId = useSelector(
    (state) => state.LoginReducer.UserData.user.centerId
  );
  const totalElements = useSelector(
    (state) =>
      state.centerInstructors.centerInstructorsData?.page?.totalElements
  );
  const modalOpen = useSelector((state) => state.UserReducer.openModal);

  const [isShowModal, setShowModal] = useState(false);
  const [rowData, setRowData] = useState(emptyString);
  const [mode, setMode] = useState(modeConstants.EDIT_MODE);
  const [gridState, setGridState] = useState(initialGridState);
  const [inputSearch, setInputSearch] = useState(emptyString);
  const [defaultPage, setDefaultPage] = useState(gridState.pageNumber);
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [userToDelete, setUserToDelete] = useState("");
  const [instructorData, setInstructorData] = useState(null);

  useEffect(() => {
    dispatch(centerInstructorsActions.resetInstructorDetails());
  }, [isShowModal]);

  const onDelete = (row) => {
    setTitle(translationConstants.REMOVE_INSTRUCTOR);
    setMessage(
      `${t(translationConstants.ARE_YOU_SURE_TO_REMOVE)}, ${
        row?.englishFirstName
      }, ${t(translationConstants.FROM_INSTRUCTORS_LIST)}`
    );
    setUserToDelete(row);
    dispatch(UserActions.OpenModal(true));
  };

  const getcolumns = (t, getRowData, setMode) => [
    {
      id: "englishFirstName",
      name: t(translationConstants.fullName),
      selector: (row) => `${row.englishFirstName} ${row.englishLastName}`,
      reorder: true,
      sortable: true,
      sortDirection: null,
    },
    {
      id: "email",
      name: t(translationConstants.Email),
      selector: (row) => row?.email,
      reorder: true,
      sortable: true,
      sortDirection: null,
    },
    {
      id: "sportIds",
      name: t(translationConstants.SPORTS),
      selector: (row) =>
        getSportNames(row.sportLevels.map((item) => item.sportId)),
      minWidth: "130px",
      minWidth: "130px",
      cell: (row) => (
        <div style={{ minWidth: "130px" }}>
          {getSportNames(row.sportLevels.map((item) => item.sportId))}
        </div>
      ),
    },
    {
      id: "noOfHours",
      accessor: "noOfHours",
      name: t(translationConstants.noOfHours),
      selector: (row) => row.noOfHours,
      reorder: true,
      sortable: true,
      sortDirection: null,
      minWidth: "140px",
      cell: (row) => <div style={{ minWidth: "140px" }}>{row.noOfHours}</div>,
    },
    {
      id: "noOfStudents",
      accessor: "noOfStudents",
      name: t(translationConstants.noOfStudents),
      selector: (row) => row.noOfStudents,
      reorder: true,
      sortable: true,
      sortDirection: null,
      minWidth: "160px",
      cell: (row) => (
        <div style={{ minWidth: "160px" }}>{row.noOfStudents}</div>
      ),
    },
    {
      id: "rating",
      name: t(translationConstants.RATING),
      selector: (row) => `${row?.rating.toFixed(1)}/5`,
      reorder: true,
      sortable: true,
      sortDirection: null,
    },
    {
      id: "centerInvitationStatus",
      accessor: "centerInvitationStatus",
      name: t(translationConstants.STATUS),
      selector: (row) => row.centerInvitationStatus,
      reorder: true,
      sortable: true,
      sortDirection: null,
      cell: (row) => (
        <span className="capitalize-first">
          {t(centerInvitationStatusConstants[row.centerInvitationStatus])}
        </span>
      ),
    },
    {
      id: "actions",
      name: t(translationConstants.Actions),
      cell: (row) => (
        <>
          <svg
            onClick={() => {
              getRowData(row);
              setMode(modeConstants.VIEW_MODE);
            }}
            className="mx-1"
            width="20"
            height="20"
            // viewBox="0 0 50 16"
            viewBox="0 0 20 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.1685 8.99922C16.1685 8.99922 14.0341 13.268 9.05391 13.268C4.07371 13.268 1.93933 8.99922 1.93933 8.99922C1.93933 8.99922 4.07371 4.73047 9.05391 4.73047C14.0341 4.73047 16.1685 8.99922 16.1685 8.99922Z"
              stroke="#588930"
              strokeWidth="1.42292"
              strokeLinecap="round"
            />
            <circle
              cx="9.05381"
              cy="8.99766"
              r="2.13438"
              stroke="#588930"
              strokeWidth="1.42292"
              strokeLinecap="round"
            />
          </svg>
          {row?.centerInvitationStatus === centerInvitationStatuses.Pending ? (
            <img
              src={removeIcon}
              alt="Remove Instructor"
              className="mx-1 cursor-pointer"
              width="12"
              onClick={() => {
                setMode(modeConstants.CANCEL_MODE);
                onDelete(row);
              }}
            />
          ) : row?.centerInvitationStatus ===
            centerInvitationStatuses.Approved ? (
            <img
              src={removeInstructorIcon}
              alt="Remove Instructor"
              className="mx-1 cursor-pointer"
              width="15"
              onClick={() => {
                setMode(modeConstants.CANCEL_MODE);
                onDelete(row);
              }}
            />
          ) : (
            <></>
          )}
        </>
      ),
    },
  ];

  const onSetShow = () => {
    setShowModal((prev) => !prev);
  };

  const getRowData = (data) => {
    onSetShow();
    setInstructorData(data);
  };

  const [columns, setColumns] = useState(getcolumns(t, getRowData, setMode));

  const onSort = (sortedColumn) => {
    sortingInProgressRef.current = true;
    setColumns(changeTableSortIcons(columns, sortedColumn));
    const columnDirection = getSortDirectionProperty(sortedColumn);
    setDefaultPage(gridState.pageNumber);
    setGridState((prevState) => ({
      ...prevState,
      orderBy: columnDirection ? `${sortedColumn.id} ${columnDirection}` : null,
    }));
  };

  useEffect(() => {
    setRowData(publicData);
    // eslint-disable-next-line
  }, [publicData]);

  const onChangePage = (pageNumber) => {
    if (!sortingInProgressRef.current) {
      setGridState((prevState) => ({
        ...prevState,
        pageNumber: pageNumber,
      }));
    }
  };

  const onChangeRowsPerPage = (newPerPage, pageNumber) => {
    setGridState((prevState) => ({
      ...prevState,
      length: newPerPage,
      pageNumber: pageNumber,
    }));
  };

  const removeRowData = (data) => {
    dispatch(
      centerInstructorsActions.removeCenterInstructor(
        centerId,
        data?.instructorId,
        gridState
      )
    );
    if (mode === modeConstants.VIEW_MODE) {
      setMode(modeConstants.EDIT_MODE);
      onSetShow();
    }
    dispatch(UserActions.OpenModal(false));
  };

  useEffect(() => {
    dispatch(
      centerInstructorsActions.getCenterInstructors(centerId, gridState)
    );
    sortingInProgressRef.current = false;
    // eslint-disable-next-line
  }, [gridState]);

  useEffect(() => {
    setGridState((prevState) => ({
      ...prevState,
      search: inputSearch,
    }));
    // eslint-disable-next-line
  }, [inputSearch]);

  useEffect(() => {
    setColumns(getcolumns(t, getRowData, setMode));
    // eslint-disable-next-line
  }, [i18n.dir()]);

  return (
    <div className="UserDiv">
      {mode === modeConstants.VIEW_MODE ? (
        <>
          <div className="d-flex align-items-center py-3">
            <span
              className="cursor-pointer rotated-element"
              onClick={() => {
                setMode(modeConstants.EDIT_MODE);
                onSetShow();
              }}
            >
              <img src={BTN_BACK} />
            </span>
          </div>
          <InstructorDetail
            instructorData={instructorData}
            onDelete={onDelete}
            isShowRemoveButton={
              instructorData?.centerInvitationStatus ===
              centerInvitationStatuses.Approved
            }
          />
        </>
      ) : (
        <div>
          <p className="UserTabHeading capitalize-first mx-0 mb-3">
            {t(translationConstants.INSTRUCTORS)}
          </p>

          <div className="tableContainer">
            <FilterComponent
              isStatusFilterAllowed={true}
              gridState={gridState}
              setGridState={setGridState}
              defaultQueryExpression={defaultQueryExpression}
            >
              <div className="mb-4">
                <Button
                  className="Registeration-button m-0"
                  type="button"
                  onClick={() => {
                    onSetShow();
                    setMode(modeConstants.ADD_MODE);
                  }}
                >
                  <svg
                    width="10"
                    height="14"
                    viewBox="0 0 13 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="me-2"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M5.6239 7.87686L0.305033 7.87686L0.305033 6.12465L5.6239 6.12465L5.6239 0.805788H7.3761L7.3761 6.12465L12.695 6.12465L12.695 7.87686L7.3761 7.87686L7.3761 13.1957H5.6239L5.6239 7.87686Z"
                      fill="white"
                    />
                  </svg>
                  &nbsp;
                  {t(translationConstants.ADD_NEW)}
                </Button>
              </div>
            </FilterComponent>

            <DataTable
              columns={columns}
              items={rowData}
              onSort={onSort}
              paginationDefaultPage={defaultPage}
              paginationResetDefaultPage={true}
              gridState={gridState}
              paginationTotalRows={totalElements}
              onChangeRowsPerPage={onChangeRowsPerPage}
              onChangePage={onChangePage}
            />

            <CustomModal
              size="lg"
              scrollable={true}
              setShow={onSetShow}
              show={isShowModal}
            >
              <div className="">
                <AddInstructorModal
                  setShow={setShowModal}
                  gridState={gridState}
                  totalElements={totalElements}
                />
              </div>
            </CustomModal>
          </div>
        </div>
      )}
      <CustomModal
        scrollable={true}
        size="md"
        setShow={() => dispatch(UserActions.OpenModal(false))}
        show={modalOpen}
        customClass="view-user-modal"
      >
        <DeleteModal
          title={title}
          message={message}
          bold={true}
          dataToDelete={userToDelete}
          removeRowData={removeRowData}
          onCancel={() => dispatch(UserActions.OpenModal(false))}
        />
      </CustomModal>
    </div>
  );
};

export default CenterInstructors;
